import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { catchError, of, switchMap, tap } from 'rxjs';
import {
  DisbursementHistoryDetailFactoryService,
  DisbursementHistoryDetailParams,
  DisbursementHistoryDetailState,
} from '../factory/disbursement-history-detail-store-factory';
import { DisbursementHistoryDetailApiService } from '../services/disbursement-history-detail.api.service';

const initialState: DisbursementHistoryDetailState = {
  errorMessage: '',
  isLoading: false,
  currentDisbursementHistory: null,
  downloadUrl: null,
};

@Injectable()
export class DisbursementHistoryDetailStore
  extends ComponentStore<DisbursementHistoryDetailState>
  implements DisbursementHistoryDetailFactoryService
{
  constructor(private disbursementHistoryDetailApiService: DisbursementHistoryDetailApiService) {
    super(initialState);
  }

  errorMessage$ = this.select(state => state.errorMessage);
  isLoading$ = this.select(state => state.isLoading);
  currentDisbursementHistory$ = this.select(state => state.currentDisbursementHistory);

  vm$ = this.select(state => state);

  readonly requestDisbursementHistory = this.effect<DisbursementHistoryDetailParams>(params$ =>
    params$.pipe(
      tap(() =>
        this.patchState({
          isLoading: true,
          currentDisbursementHistory: null,
          downloadUrl: null,
        })
      ),
      switchMap(params =>
        this.disbursementHistoryDetailApiService.getDisbursementHistoryDetail(params.id, params.subMerchantId).pipe(
          tap({
            next: response => {
              this.patchState({
                currentDisbursementHistory: response.data,
                isLoading: false,
              });
            },
            error: error => {
              this.patchState({
                errorMessage: error.message,
                isLoading: false,
              });
            },
          }),
          catchError(error => {
            this.patchState({
              errorMessage: error.message,
              isLoading: false,
            });
            return of([]);
          })
        )
      )
    )
  );

  readonly downloadRecepit = this.effect<DisbursementHistoryDetailParams>(params$ =>
    params$.pipe(
      tap(() => this.patchState({ isLoading: true })),
      switchMap(params =>
        this.disbursementHistoryDetailApiService.downloadReceipt(params.id, params.subMerchantId).pipe(
          tap({
            next: response => {
              this.patchState({
                downloadUrl: response.data.receiptUrl,
                isLoading: false,
              });
            },
            error: error => {
              this.patchState({
                errorMessage: error.message,
                isLoading: false,
              });
            },
          }),
          catchError(error => {
            this.patchState({
              errorMessage: error.message,
              isLoading: false,
            });
            return of([]);
          })
        )
      )
    )
  );
}
